import { render, staticRenderFns } from "./Ribbons.vue?vue&type=template&id=3390baf3&scoped=true&lang=pug"
import script from "./Ribbons.vue?vue&type=script&lang=js"
export * from "./Ribbons.vue?vue&type=script&lang=js"
import style0 from "./Ribbons.vue?vue&type=style&index=0&id=3390baf3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3390baf3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3390baf3')) {
      api.createRecord('3390baf3', component.options)
    } else {
      api.reload('3390baf3', component.options)
    }
    module.hot.accept("./Ribbons.vue?vue&type=template&id=3390baf3&scoped=true&lang=pug", function () {
      api.rerender('3390baf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/anniversary2023/components/Ribbons.vue"
export default component.exports